import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  key: 0,
  class: "login-wrapper local-login"
}
const _hoisted_3 = { class: "form-hd" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "btn-container" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "login-wrapper ldap-login"
}
const _hoisted_6 = { class: "form-hd" }

import { login as loginApi } from '@/api/common'
import { ADMIN_USERNAMES, DEFAULT_PWD } from '@/common/constants'
import useSSO from '@/hooks/SSO/useSSO'
import useDocLink from '@/hooks/useDocLink'
import useEditionConfigs from '@/hooks/useEditionConfigs'
import useFormRules from '@/hooks/useFormRules'
import useUpdateBaseInfo from '@/hooks/useUpdateBaseInfo'
import { toLogin } from '@/router'
import { PostLogin200 } from '@/types/schemas/dashboard.schemas'
import { ArrowLeft } from '@element-plus/icons-vue'
import { onBeforeMount, onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useStore, mapGetters } from 'vuex'
import ResetPassword from './ResetPassword.vue'
import banner from '@/assets/img/banner.jpeg'
import { useMapGetters } from '@/hooks/Webhook/mapGetters'
import FooterInfo from '@/components/FooterInfo.vue'
import { getMenus } from '@/store/tool'
import { menus as menusApi } from '@/api/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const store = useStore()
const router = useRouter()
const route = useRoute()
const { systemInfo } = useMapGetters('systemStore', ['systemInfo'])
const { loginTitle, loginBgBanner } = useEditionConfigs()

const { docMap } = useDocLink()

const { currentLoginBackend, isSSOLoading, ldapRecord, ldapLogin, getEnabledSSO } = useSSO()

getEnabledSSO()
const record = reactive({
  username: '',
  password: '',
})
const newPasswordRecord = reactive({
  password: '',
  passwordRepeat: '',
})
const isSubmitting = ref(false)

const showChangePwdForm = ref(false)
const isUsingDefaultPwd = ref(false)
const rules = {
  username: [{ required: true, message: t('Base.unameRequired') }],
  password: [{ required: true, message: t('Base.passwordRequired') }],
}
const { createRequiredRule } = useFormRules()
const FormCom = ref()
const PwdFormCom = ref()

const { updateBaseInfo } = useUpdateBaseInfo()
const updateStoreInfo = (username: string, data: PostLogin200) =>
  updateBaseInfo(username, data, currentLoginBackend.value)

const queryLogin = async ({ username, password }: { username: string; password: string }) => {
  isSubmitting.value = true
  try {
    const res = await loginApi({ name: username, passwd: password })
    isUsingDefaultPwd.value = password === DEFAULT_PWD && ADMIN_USERNAMES.includes(username)
    const data = { role: res.rid, token: res.token, version: 'v1.1.0', inChina: res.inChina }
    updateStoreInfo(username, data)
    if (!isUsingDefaultPwd.value) {
      redirectToDashboard()
    } else {
      showChangePwdForm.value = true
    }
    return Promise.resolve({ username, response: res })
  } catch (error) {
    return Promise.reject(error)
  } finally {
    isSubmitting.value = false
  }
}
onMounted(() => {
  store.dispatch('systemStore/getSystemInfo')
})

const login = async (auto = false) => {
  const { username, token } = (auto && store.state.user) || record
  if (auto && username && token) {
    redirectToDashboard()
  } else {
    toLogin()
  }
  if (!auto) {
    await queryLogin(record)
  }
}

const getFirstPermissRouterPath = async (): Promise<string> => {
  const data = await menusApi()
  store.dispatch('SET_MENUS', data || [])
  if (data && data.length > 0) {
    const path: string | undefined =
      data[0].path !== '' ? data[0].path : data[0].children && data[0].children[0].path
    return path ?? '/'
  } else {
    return '/'
  }
}
const redirectToDashboard = async () => {
  const path: string = await getFirstPermissRouterPath()
  router.replace({
    path: path,
  })
}

const submit = async () => {
  const isValidated = await FormCom.value.validate().catch(() => false)
  if (!isValidated) {
    return
  }
  switch (currentLoginBackend.value) {
    case 'local':
      login()
      break
    case 'ldap':
      ldapLogin()
        .then(({ username, response }) => {
          updateStoreInfo(username as string, response)
          redirectToDashboard()
        })
        .catch(() => {
          // ignore
        })
      break
    default:
      login()
      break
  }
}

onBeforeMount(() => {})

onMounted(() => {})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dashboard-img",
      style: _normalizeStyle({
        backgroundImage: `url(${_unref(systemInfo)?.domainIsConfig ? _unref(systemInfo).loginImage : _unref(banner)})`,
      }),
      alt: ""
    }, null, 4),
    (!showChangePwdForm.value)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "form-container",
          gutter: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 8,
              class: "form-container-title"
            }),
            _createVNode(_component_el_col, {
              span: 8,
              xl: 6,
              class: "form"
            }, {
              default: _withCtx(() => [
                (_unref(currentLoginBackend) === 'local')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", null, _toDisplayString(`${_ctx.$t('Base.login')} - ${_unref(systemInfo).loginTitle ?? _unref(loginTitle)}`), 1)
                      ]),
                      _createVNode(_component_el_form, {
                        ref_key: "FormCom",
                        ref: FormCom,
                        model: _unref(record),
                        rules: rules,
                        "hide-required-asterisk": "",
                        size: "large",
                        onKeyup: _withKeys(submit, ["enter"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "username" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(record).username,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(record).username) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: _ctx.$t('Base.username'),
                                tabindex: "1"
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "small-mg-bt",
                            prop: "password"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(record).password,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(record).password) = $event)),
                                type: "password",
                                placeholder: _ctx.$t('Base.password'),
                                tabindex: "2"
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }),
                          _hoisted_4,
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "btn-login",
                                type: "primary",
                                onClick: submit,
                                loading: isSubmitting.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('Base.login')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "onKeyup"])
                    ]))
                  : (_unref(currentLoginBackend) === 'ldap')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_el_page_header, {
                          icon: _unref(ArrowLeft),
                          onBack: _cache[2] || (_cache[2] = ($event: any) => (currentLoginBackend.value = 'local'))
                        }, null, 8, ["icon"]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Base.ldapLogin')), 1)
                        ]),
                        _createVNode(_component_el_form, {
                          ref_key: "FormCom",
                          ref: FormCom,
                          model: _unref(ldapRecord),
                          rules: rules,
                          "hide-required-asterisk": "",
                          size: "large",
                          onKeyup: _withKeys(submit, ["enter"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { prop: "username" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(ldapRecord).username,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(ldapRecord).username) = $event)),
                                  modelModifiers: { trim: true },
                                  placeholder: _ctx.$t('Base.username'),
                                  tabindex: "1"
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "small-mg-bt",
                              prop: "password"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(ldapRecord).password,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(ldapRecord).password) = $event)),
                                  type: "password",
                                  placeholder: _ctx.$t('Base.password'),
                                  tabindex: "2"
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  class: "btn-login",
                                  type: "primary",
                                  onClick: submit,
                                  loading: _unref(isSSOLoading)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Base.login')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model", "onKeyup"])
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(ResetPassword, {
          key: 1,
          onLogin: queryLogin
        })),
    _createVNode(FooterInfo)
  ]))
}
}

})